export type ClientFlow = { flowId: string; action: string }

let currentFlow: ClientFlow | null = null

function generateId(): string {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID()
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`
}

export function startFlow(action: string): ClientFlow {
  currentFlow = { flowId: generateId(), action: String(action || '').trim() || 'unknown_action' }
  return currentFlow
}

export function getCurrentFlow(): ClientFlow | null {
  return currentFlow
}

export function clearFlow(flowId?: string): void {
  if (!currentFlow) return
  if (!flowId || currentFlow.flowId === flowId) currentFlow = null
}
